import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./order-detail.scss";

const orderDetails = {
  "SB-10084": {
    orderNo: "SB-10084",
    vendor: "Hikari House",
    customer: "Channie",
    phone: "012-3456789",
    email: "channie@example.com",
    status: "Paid",
    paymentStatus: "Paid",
    paymentMethod: "Fiuu FPX",
    collectionTime: "Today, 6:30 PM",
    orderTime: "28 Jun 2026, 5:58 PM",
    amount: "RM18.90",
    subtotal: "RM17.90",
    platformFee: "RM1.00",
    discount: "RM0.00",
    outlet: "Kuching Central",
    remarks: "Customer will collect before 6:45 PM.",
    items: [
      { name: "Chicken Katsu Bento", qty: 1, price: "RM12.90", total: "RM12.90" },
      { name: "Matcha Latte", qty: 1, price: "RM5.00", total: "RM5.00" },
    ],
    timeline: [
      { title: "Order Created", time: "28 Jun 2026, 5:58 PM", type: "done" },
      { title: "Payment Successful", time: "28 Jun 2026, 6:01 PM", type: "done" },
      { title: "Order Paid", time: "28 Jun 2026, 6:20 PM", type: "done" },
      { title: "Ready for Pickup", time: "-", type: "pending" },
      { title: "Collected", time: "-", type: "pending" },
    ],
  },
  "SB-10081": {
    orderNo: "SB-10081",
    vendor: "Urban Cafe",
    customer: "Aaron",
    phone: "014-5566778",
    email: "aaron@example.com",
    status: "Cancelled",
    paymentStatus: "Paid",
    refundStatus: "Pending Refund",
    paymentMethod: "Fiuu FPX",
    collectionTime: "Today, 8:00 PM",
    orderTime: "1 Jul 2026, 11:15 AM",
    cancelledAt: "1 Jul 2026, 11:24 AM",
    cancelledBy: "Vendor",
    cancellationReason: "Out of stock",
    cancellationRemarks: "Sorry, we are out of Chicken Katsu.",
    amount: "RM15.80",
    subtotal: "RM14.80",
    platformFee: "RM1.00",
    discount: "RM0.00",
    outlet: "Sibu Central",
    remarks: "Please pick up at the counter. Thank you!",
    items: [
      { name: "Chicken Katsu Bento", qty: 1, price: "RM12.90", total: "RM12.90" },
      { name: "Matcha Latte", qty: 1, price: "RM2.90", total: "RM2.90" },
    ],
    timeline: [
      { title: "Order Created", time: "1 Jul 2026, 11:15 AM", type: "done" },
      { title: "Payment Successful", time: "1 Jul 2026, 11:16 AM", type: "done" },
      { title: "Order Cancelled", time: "1 Jul 2026, 11:24 AM", type: "cancelled" },
      { title: "Refund Pending", time: "Waiting for admin action", type: "pending" },
    ],
  },
  "SB-10083": {
    orderNo: "SB-10083",
    vendor: "Green Bowl",
    customer: "Daniel",
    phone: "011-2233445",
    email: "daniel@example.com",
    status: "Paid",
    paymentStatus: "Paid",
    paymentMethod: "Fiuu Card",
    collectionTime: "Today, 7:00 PM",
    orderTime: "28 Jun 2026, 6:10 PM",
    amount: "RM12.50",
    subtotal: "RM11.50",
    platformFee: "RM1.00",
    discount: "RM0.00",
    outlet: "Padungan",
    remarks: "Pending vendor preparation.",
    items: [{ name: "Healthy Rice Bowl", qty: 1, price: "RM11.50", total: "RM11.50" }],
    timeline: [
      { title: "Order Created", time: "28 Jun 2026, 6:10 PM", type: "done" },
      { title: "Payment Successful", time: "28 Jun 2026, 6:12 PM", type: "done" },
      { title: "Order Paid", time: "28 Jun 2026, 6:13 PM", type: "done" },
      { title: "Ready for Pickup", time: "-", type: "pending" },
      { title: "Collected", time: "-", type: "pending" },
    ],
  },
  "SB-10082": {
    orderNo: "SB-10082",
    vendor: "Daily Bakery",
    customer: "Mei Ling",
    phone: "016-9988776",
    email: "meiling@example.com",
    status: "Collected",
    paymentStatus: "Paid",
    paymentMethod: "2C2P E-Wallet",
    collectionTime: "Today, 5:30 PM",
    orderTime: "28 Jun 2026, 4:45 PM",
    amount: "RM9.90",
    subtotal: "RM8.90",
    platformFee: "RM1.00",
    discount: "RM0.00",
    outlet: "Miri Times Square",
    remarks: "Collected by customer.",
    items: [{ name: "Assorted Bread Set", qty: 1, price: "RM8.90", total: "RM8.90" }],
    timeline: [
      { title: "Order Created", time: "28 Jun 2026, 4:45 PM", type: "done" },
      { title: "Payment Successful", time: "28 Jun 2026, 4:46 PM", type: "done" },
      { title: "Order Paid", time: "28 Jun 2026, 4:47 PM", type: "done" },
      { title: "Ready for Pickup", time: "28 Jun 2026, 5:10 PM", type: "done" },
      { title: "Collected", time: "28 Jun 2026, 5:28 PM", type: "done" },
    ],
  },
};

const statusClass = (value) => String(value).toLowerCase().replace(/\s+/g, "-");

const timelineIcon = (type, title) => {
  if (type === "pending") return "ti ti-check";
  if (type === "cancelled") return "ti ti-x";
  if (title.toLowerCase().includes("payment")) return "ti ti-credit-card";
  if (title.toLowerCase().includes("paid")) return "ti ti-check";
  if (title.toLowerCase().includes("pickup")) return "ti ti-shopping-bag";
  if (title.toLowerCase().includes("collect")) return "ti ti-check";
  if (title.toLowerCase().includes("refund")) return "ti ti-refresh";
  return "ti ti-receipt";
};

const InfoItem = ({ label, value }) => (
  <div className="order-detail__info-item">
    <span>{label}</span>
    <strong>{value || "-"}</strong>
  </div>
);

const OrderDetailPage = () => {
  const navigate = useNavigate();
  const { orderNo } = useParams();
  const order = orderDetails[orderNo] || orderDetails["SB-10081"];
  const [refundStatus, setRefundStatus] = useState(order.refundStatus || "");
  const [isActionOpen, setIsActionOpen] = useState(false);
  const isCancelled = order.status === "Cancelled";
  const canMarkRefunded = isCancelled && refundStatus !== "Refunded";

  const handleMarkRefunded = () => {
    if (!canMarkRefunded) return;
    setRefundStatus("Refunded");
    setIsActionOpen(false);
  };

  return (
    <div className="order-detail">
      <section className="order-detail__hero">
        <div className="order-detail__container">
          <button className="order-detail__back" type="button" onClick={() => navigate("/admin/orders")}>
            <i className="ti ti-arrow-left" style={{ fontSize: 13 }}></i> Back to Orders
          </button>

          <div className="order-detail__hero-content">
            <div>
              <p className="order-detail__eyebrow">SecondBite Admin</p>
              <div className="order-detail__title-row">
                <h2>Order {order.orderNo}</h2>
                <span className={`order-detail__status order-detail__status--${statusClass(order.status)}`}>
                  {order.status}
                </span>
              </div>
              <p>
                Review order details, customer information, payment status
                {isCancelled ? ", cancellation reason, and manage refund." : ", and collection progress."}
              </p>
            </div>

            <div className="order-detail__actions-dropdown">
              <button type="button" onClick={() => setIsActionOpen((value) => !value)}>
                Actions <i className="ti ti-chevron-down" aria-hidden="true"></i>
              </button>
              {isActionOpen && (
                <div className="order-detail__actions-menu">
                  {isCancelled && (
                    <button type="button" disabled={!canMarkRefunded} onClick={handleMarkRefunded}>
                      <i className="ti ti-refresh" aria-hidden="true"></i> {refundStatus === "Refunded" ? "Refunded" : "Mark as Refunded"}
                    </button>
                  )}
                  {isCancelled && <button type="button"><i className="ti ti-mail" aria-hidden="true"></i> View Cancellation Email</button>}
                  <button type="button"><i className="ti ti-printer" aria-hidden="true"></i> Print Order</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="order-detail__summary-section">
        <div className="order-detail__container">
          <div className="order-detail__summary-grid">
            <InfoItem label="Customer" value={`${order.customer} / ${order.phone}`} />
            <InfoItem label="Vendor" value={order.vendor} />
            <InfoItem label="Outlet" value={order.outlet} />
            <InfoItem label="Collection Time" value={order.collectionTime} />
            <InfoItem label="Total Amount" value={order.amount} />
          </div>
        </div>
      </section>

      <section className="order-detail__container order-detail__timeline-section">
        <div className="order-detail__timeline-panel">
          <div className="order-detail__panel-title">
            <h3>Order Timeline</h3>
          </div>
          <div className="order-detail__timeline-bar" style={{ "--timeline-count": order.timeline.length }}>
            {order.timeline.map((item, index) => (
              <div
                className={`order-detail__timeline-step order-detail__timeline-step--${item.type}`}
                key={`${item.title}-${item.time}`}
                style={{ "--step-index": index }}
              >
                <div className="order-detail__timeline-node">
                  <i className={timelineIcon(item.type, item.title)} aria-hidden="true"></i>
                </div>
                <div className="order-detail__timeline-copy">
                  <strong>{item.title}</strong>
                  <p>{item.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="order-detail__container order-detail__content-section">
        <div className="order-detail__content-grid">
          <div className="order-detail__panel order-detail__panel--items">
            <div className="order-detail__panel-title">
              <h3>Order Items</h3>
            </div>

            <div className="order-detail__items">
              <div className="order-detail__items-head">
                <span>Item</span>
                <span>Qty</span>
                <span>Price</span>
                <span>Total</span>
              </div>
              {order.items.map((item) => (
                <div className="order-detail__items-row" key={item.name}>
                  <strong>{item.name}</strong>
                  <span>{item.qty}</span>
                  <span>{item.price}</span>
                  <span>{item.total}</span>
                </div>
              ))}
            </div>

            <div className="order-detail__totals">
              <div><span>Subtotal</span><strong>{order.subtotal}</strong></div>
              <div><span>Platform Fee</span><strong>{order.platformFee}</strong></div>
              <div><span>Discount</span><strong>{order.discount}</strong></div>
              <div className="order-detail__grand-total"><span>Grand Total</span><strong>{order.amount}</strong></div>
            </div>
          </div>

          {isCancelled ? (
            <div className="order-detail__panel order-detail__status-panel">
              <div className="order-detail__panel-title">
                <h3>Order Status</h3>
              </div>
              <div className="order-detail__cancelled-banner">Cancelled</div>
              <div className="order-detail__status-list">
                <InfoItem label="Cancelled By" value={order.cancelledBy} />
                <InfoItem label="Cancellation Reason" value={order.cancellationReason} />
                <InfoItem label="Cancellation Remarks" value={order.cancellationRemarks || order.remarks} />
                <InfoItem label="Cancelled At" value={order.cancelledAt} />
              </div>

              <div className="order-detail__refund-box">
                <h4>Refund Status</h4>
                <InfoItem label="Refund Status" value={refundStatus || "Not Required"} />
                <InfoItem label="Refund Method" value={order.paymentMethod} />
                <InfoItem label="Refund Amount" value={order.amount} />
                <button
                  className="order-detail__refund-button"
                  type="button"
                  disabled={!canMarkRefunded}
                  onClick={handleMarkRefunded}
                >
                  <i className="ti ti-refresh" aria-hidden="true"></i> {refundStatus === "Refunded" ? "Refunded" : "Mark as Refunded"}
                </button>
              </div>
            </div>
          ) : (
            <div className="order-detail__panel">
              <div className="order-detail__panel-title">
                <h3>Payment</h3>
              </div>
              <InfoItem label="Payment Status" value={order.paymentStatus} />
              <InfoItem label="Payment Method" value={order.paymentMethod} />
              <InfoItem label="Order Time" value={order.orderTime} />
            </div>
          )}

          <div className="order-detail__panel order-detail__customer-panel">
            <div className="order-detail__panel-title">
              <h3>Customer & Collection</h3>
            </div>
            <InfoItem label="Customer Email" value={order.email} />
            <InfoItem label="Outlet" value={order.outlet} />
            <InfoItem label="Collection Instructions" value={order.remarks} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrderDetailPage;
